import React, { useEffect, useState } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/Mirissa.css";

import { storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";

function Yala() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [imgHero, setImgHero] = useState("");

  // Top gallery
  const [yala1, setYala1] = useState("");
  const [yala2, setYala2] = useState("");

  // Extra gallery
  const [yala3, setYala3] = useState("");
  const [yala4, setYala4] = useState("");
  const [yala5, setYala5] = useState("");

  // Activity icons – Entering Yala
  const [bear, setBear] = useState("");
  const [dear, setDear] = useState("");
  const [adventure, setAdventure] = useState("");

  // Safari Adventure icons
  const [caption, setCaption] = useState("");
  const [caption1, setCaption1] = useState("");
  const [caption2, setCaption2] = useState("");

  // Coastal Area icons
  const [caption3, setCaption3] = useState("");
  const [caption4, setCaption4] = useState("");
  const [caption5, setCaption5] = useState("");

  // Final gallery
  const [yala6, setYala6] = useState("");
  const [yala7, setYala7] = useState("");

  useEffect(() => {

    getDownloadURL(ref(storage, "yala-hero.jpg")).then(setImgHero);

    // TOP GALLERY
    getDownloadURL(ref(storage, "yala1.jpg")).then(setYala1);
    getDownloadURL(ref(storage, "yala2.jpg")).then(setYala2);

    // EXTRA GALLERY
    getDownloadURL(ref(storage, "yala3.jpg")).then(setYala3);
    getDownloadURL(ref(storage, "yala4.jpg")).then(setYala4);
    getDownloadURL(ref(storage, "yala5.jpg")).then(setYala5);

    // ENTERING YALA
    getDownloadURL(ref(storage, "Sri Lanka Bear.png")).then(setBear);
    getDownloadURL(ref(storage, "Sri Lanka Dear.png")).then(setDear);
    getDownloadURL(ref(storage, "Maximum adventure.png")).then(setAdventure);

    // SAFARI ADVENTURE
    getDownloadURL(ref(storage, "caption.png")).then(setCaption);
    getDownloadURL(ref(storage, "caption1.png")).then(setCaption1);
    getDownloadURL(ref(storage, "caption2.png")).then(setCaption2);

    // COASTAL BELT
    getDownloadURL(ref(storage, "caption3.png")).then(setCaption3);
    getDownloadURL(ref(storage, "caption4.png")).then(setCaption4);
    getDownloadURL(ref(storage, "caption5.png")).then(setCaption5);

    // PARROT ROCK / FINAL SECTION
    getDownloadURL(ref(storage, "yala6.jpg")).then(setYala6);
    getDownloadURL(ref(storage, "yala7.jpg")).then(setYala7);

  }, []);

  return (
    <div className="destination-container">
      {/* HERO SECTION */}
      <section
        className="mirissa-hero"
        style={{ backgroundImage: `url(${imgHero})` }}
        data-aos="fade-down"
      >
        <div className="overlay">
          <h1>Yala National Park</h1>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="mirissa-container">

        {/* LEFT CONTENT */}
        <div className="mirissa-left" data-aos="fade-right">

          <h2>Yala National Park</h2>
          <p>
            Yala National Park is one of Sri Lanka’s most popular wildlife destinations, known for its diverse ecosystems and abundant wildlife, including the elusive leopard.
          </p>

          <p>
            Yala is a renowned national park located in the southeast of Sri Lanka.
            It covers 979 square kilometers and is home to a variety of animals, including elephants, leopards, and a multitude of bird species.
            The park’s breathtaking scenery and rich biodiversity make it a must-visit destination for wildlife enthusiasts.
          </p>

          <div className="mirissa-gallery">
            <img src={yala1} alt="Yala View" />
            <img src={yala2} alt="Yala View" />
          </div>

          <p>
            A visit to Yala offers a unique opportunity to witness nature at its most raw.
            Visitors often embark on safaris to spot the park’s famous animals in their natural habitats.
            The experience of driving through the park, with the sounds of nature all around, is unforgettable.
            The park is also a key conservation area for the Sri Lankan leopard, one of the rarest wildcats in the world.
          </p>

          <ul className="mirissa-list">
            <li>Spot the elusive Sri Lankan leopard</li>
            <li>Explore the beautiful coastal areas of Yala</li>
            <li>Witness the herds of wild elephants</li>
            <li>Enjoy a guided safari experience</li>
          </ul>

          {/* EXTRA CONTENT FROM SCREENSHOT */}
          <div className="mirissa-extra" data-aos="fade-up">

            <div className="mirissa-top-gallery">
              <img src={yala3} alt="Yala View" />
              <img src={yala4} alt="Yala View" />
              <img src={yala5} alt="Yala View" />
            </div>

            <p>
              The park is divided into five blocks, each with its own unique ecosystem.
              Block I is the most popular for safaris and has the highest concentration of wildlife.
            </p>

            <p>
              Yala's coastal belt also offers a stunning view of the Indian Ocean,
              making it a perfect spot for photography and relaxation after a thrilling safari.
            </p>

          </div>

          {/* ACTIVITIES SECTION */}
          <div className="mirissa-activities" data-aos="fade-up">

            <details className="activity-box" open>
              <summary>• Entering Yala National Park</summary>

              <p>
                As you enter Yala, you will be greeted by the sight of dense forests, grasslands, and waterholes.
                The journey begins with a sense of anticipation as you spot your first glimpse of wildlife, such as deer or monkeys, along the road.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={bear} alt="Bear" />
                  <p>Sri Lanka Bear</p>
                </div>

                <div className="activity-card">
                  <img src={dear} alt="Dear" />
                  <p>Sri Lanka Dear</p>
                </div>

                <div className="activity-card">
                  <img src={adventure} alt="Adventure" />
                  <p>Maximum adventure</p>
                </div>
              </div>

            </details>

            <details className="activity-box">
              <summary>• The Safari Adventure</summary>

              <p>
                The real adventure begins as you embark on a safari. A guide will lead you through the park’s well-maintained trails,
                where you can spot elephants, crocodiles, and perhaps the legendary Sri Lankan leopard.
                The park’s varying landscapes – from forests to open plains – offer a range of habitats for different species.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={caption} alt="caption" />
                  <p>caption</p>
                </div>

                <div className="activity-card">
                  <img src={caption1} alt="caption" />
                  <p>caption</p>
                </div>

                <div className="activity-card">
                  <img src={caption2} alt="caption" />
                  <p>caption</p>
                </div>
              </div>

            </details>

            <details className="activity-box">
              <summary>• Exploring the Coastal Belt</summary>

              <p>
                After an exciting safari, the journey leads you to Yala’s coastal areas, where you can relax by the pristine beaches and observe seabirds and marine life.
                The sunset over the ocean provides the perfect end to your Yala adventure, offering stunning views and a peaceful atmosphere.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={caption3} alt="caption" />
                  <p>caption</p>
                </div>

                <div className="activity-card">
                  <img src={caption4} alt="caption" />
                  <p>caption</p>
                </div>

                <div className="activity-card">
                  <img src={caption5} alt="caption" />
                  <p>caption</p>
                </div>
              </div>
            </details>
          </div>

          {/* PARROT ROCK SECTION */}
          <div className="mirissa-parrot-rock" data-aos="fade-up">

            <div className="parrot-gallery">
              <img src={yala6} alt="Yala" />
              <img src={yala7} alt="Yala" />
            </div>

          </div>

        </div>

        {/* RIGHT INQUIRY FORM */}
        <div className="mirissa-form" data-aos="fade-left">
          <h3>Make an Inquiry</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              const name = e.target.name.value;
              const email = e.target.email.value;
              const country = e.target.country.value;
              const code = e.target.code.value;
              const phone = e.target.phone.value;
              const arrival = e.target.arrival.value;
              const departure = e.target.departure.value;
              const interest = e.target.interest.value;
              const vehicle = e.target.vehicle.value;   // ✅ NEW
              const adults = e.target.adults.value;
              const kids = e.target.kids.value;
              const message = e.target.message.value;

              const fullMessage = `
                📌 NEW TOUR BOOKING

                👤 Name: ${name}
                📧 Email: ${email}
                🌍 Country: ${country}
                📞 Phone: ${code} ${phone}
                📅 Arrival: ${arrival}
                📅 Departure: ${departure}
                🎯 Interest: ${interest}
                🚗 Vehicle Preference: ${vehicle}
                👨‍👩‍👧 Adults: ${adults}
                🧒 Kids: ${kids}

                💬 Message: ${message} 
              `;

              // ✅ SEND WHATSAPP
              const whatsappNumber = "94710440430"; // your WhatsApp number
              const whatsappURL =
                "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(fullMessage);

              window.open(whatsappURL, "_blank");

              // ✅ SEND EMAIL
              const mailto =
                "mailto:ceylongracetravels@gmail.com" +
                "?subject=" + encodeURIComponent("New Tour Booking") +
                "&body=" + encodeURIComponent(fullMessage);

              window.location.href = mailto;

              alert("✅ Your Booking is Send!");
            }}
          >
            <input name="name" type="text" placeholder="Name *" />
            <input name="email" type="email" placeholder="Email Address *" />

            <select name="country" required>
              <option value="">Choose Your Country *</option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
              <option value="Botswana">Botswana</option>
              <option value="Brazil">Brazil</option>
              <option value="Brunei">Brunei</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cabo Verde">Cabo Verde</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Central African Republic">Central African Republic</option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
              <option value="Congo, Republic of the">Congo, Republic of the</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Côte d’Ivoire">Côte d’Ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Eswatini">Eswatini</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Greece">Greece</option>
              <option value="Grenada">Grenada</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-Bissau">Guinea-Bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Honduras">Honduras</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran">Iran</option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, North">Korea, North</option>
              <option value="Korea, South">Korea, South</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Laos">Laos</option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libya">Libya</option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia">Micronesia</option>
              <option value="Moldova">Moldova</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar (Burma)">Myanmar (Burma)</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="North Macedonia">North Macedonia</option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Qatar">Qatar</option>
              <option value="Romania">Romania</option>
              <option value="Russia">Russia</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">Sao Tome and Principe</option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Sudan">South Sudan</option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syria">Syria</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-Leste">Timor-Leste</option>
              <option value="Togo">Togo</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Vatican City">Vatican City</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Vietnam">Vietnam</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>

            <div className="phone-row">
              <input name="code" className="code" type="text" placeholder="Code" />
              <input name="phone" className="phone" type="text" placeholder="Phone Number *" />
            </div>

            <label htmlFor="arrival">Arrival Date</label>
            <input name="arrival" type="date" />

            <label htmlFor="departure">Departure Date</label>
            <input name="departure" type="date" />

            <select name="interest">
              <option value="">Choose Your Interest *</option>
              <option value="Eco">Eco</option>
              <option value="Beach">Beach</option>
              <option value="Cultural">Cultural</option>
              <option value="Adventure">Adventure</option>
              <option value="Wild Life">Wild Life</option>
              <option value="Relax and Wellness">Relax and Wellness</option>
              <option value="Honeymoon">Honeymoon</option>
              <option value="Ramayana Trail">Ramayana Trail</option>
              <option value="All in one Trails">All in one Trails</option>
            </select>

            <select name="vehicle">
              <option value="">Select Vehicle Type *</option>
              <option value="Sedan – Toyota Prius (3 Pax)">Sedan – Toyota Prius (3 Pax)</option>
              <option value="Sedan – Toyota Axio (3 Pax)">Sedan – Toyota Axio (3 Pax)</option>
              <option value="Sedan – Honda Grace (3 Pax)">Sedan – Honda Grace (3 Pax)</option>
              <option value="Mini – Suzuki Wagon R (2 Pax)">Mini – Suzuki Wagon R (2 Pax)</option>
              <option value="Mini – Toyota Aqua (2 Pax)">Mini – Toyota Aqua (2 Pax)</option>
              <option value="Van – Suzuki Every (4 Pax)">Van – Suzuki Every (4 Pax)</option>
              <option value="Van – Mini Van (4 Pax)">Van – Mini Van (4 Pax)</option>
              <option value="Van – Toyota Noha (4 Pax)">Van – Toyota Noha (4 Pax)</option>
              <option value="Bus – Mitsubishi Rosa (12 Pax)">Bus – Mitsubishi Rosa (12 Pax)</option>
              <option value="Bus – King Long (12 Pax)">Bus – King Long (12 Pax)</option>
            </select>

            <input name="adults" type="number" placeholder="Adults *" />
            <input name="kids" type="number" placeholder="Kids" />

            <textarea name="message" placeholder="Enter your message"></textarea>

            <button type="submit">SUBMIT</button>
          </form>

        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-box">
          <div className="cta-left">
            <img src={require("../../assets/hile.png")} className="cta-icon" alt="icon" />
            <div className="cta-text">
              <h2>Ready To Adventure And Enjoy Natural</h2>
              <p>Reach Ceylon Authentic Tours & Travels For A Secure, Luxurious, And Unforgettable Adventure!</p>
            </div>
          </div>

          <img src={require("../../assets/plan.png")} className="cta-plane" alt="plane" />

          <button className="cta-btn">LET’S GET STARTED</button>
        </div>
      </section>
    </div>
  );
}

export default Yala;
